import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { ToastType } from 'models/app/toast';
import { Epic } from 'models/meta/epic';

import { showToast } from 'store/application/actions';
import {
    fetchCompanyDetailsFailure,
    fetchCompanyDetailsSuccess,
    updateCompanySuccess,
    updateCompanyFailure,
} from 'store/company/actions';
import { hideModal } from 'store/modal/actions';

import { FETCH_COMPANY_DETAILS, UPDATE_COMPANY } from './actions.types';


export const onFetchCompanyDetails: Epic = (action$, state$, { companies }) => {
    return action$.pipe(
        ofType(FETCH_COMPANY_DETAILS),
        switchMap(({ payload }) => from(companies.getCompanyDetails(payload?.queryParams))
            .pipe(
                switchMap((response) => {
                    return of(fetchCompanyDetailsSuccess({
                        responsePayload: response.data,
                        locationPathname: payload.locationPathname,
                    }));
                }),
                catchError(() => of(fetchCompanyDetailsFailure())),
            )),
    );
};

export const onUpdateCompany: Epic = (action$, state$, { companies, i18n }) => {
    return action$.pipe(
        ofType(UPDATE_COMPANY),
        switchMap(({ payload }) => from(companies.updateCompany({
            companyId: payload.companyId,
            formData: payload.formData,
        }))
            .pipe(
                switchMap(() => of(
                    // XXX empty success response - this is different from all  updates responses
                    updateCompanySuccess(payload.formData),
                    hideModal(),
                    showToast({ type: ToastType.success, message: i18n.t('company:actionMessages.updateCompanySuccess') }),
                )),
                catchError(() => of(
                    updateCompanyFailure(),
                )),
            )),
    );
};


export default [
    onFetchCompanyDetails,
    onUpdateCompany,
];
